// extracted by mini-css-extract-plugin
module.exports = {"container":"Skeleton_container__0CPFw","loader":"Skeleton_loader__UYLIo"};